<div class="container">
  <h2>Editar Perfil</h2>
  <p class="atencao">
    Para navegar no portal Ã© necessÃ¡rio que todos os campos obrigatÃ³rios(*) estejam preenchidos!
  </p>

  <div class="user-details">
    @if (isLoading) {
      <div class="loading-message"> Carregando dados do perfil...</div>
    }
    @if (!isLoading && user) {

      <form [formGroup]="userForm" (ngSubmit)="onSubmit()" novalidate>
        <fieldset>
          <div>
            <mat-label>Nome Completo Civil ou Social*:</mat-label>
            <p class="descricao">
              (preencha com o nome completo, pois o sistema irÃ¡ utilizar esses dados para emitir certificados,
              declaraÃ§Ãµes e outros documentos)
            </p>
            <mat-form-field class="full-input">
              <input matInput id="name" formControlName="name" type="text">
              @if (userForm.get('name')?.hasError('required')) {
                <mat-error>O nome Ã© obrigatÃ³rio.</mat-error>
              }
              @if (userForm.get('name')?.hasError('minlength')) {
                <mat-error>O nome deve ter pelo menos 3 caracteres.</mat-error>
              }
            </mat-form-field>

            <p class="descricao">
              (ResoluÃ§Ã£o UNESP nÂº 62/2017, que dispÃµe sobre o uso do nome social e o reconhecimento da
              identidade de
              gÃªnero de pessoas travestis e transexuais no Ã¢mbito da UNESP e dÃ¡ outras providÃªncias.)
            </p>
            <p class="descricao">* Nome social: se refere Ã  designaÃ§Ã£o pela qual a pessoa travesti ou transexual se
              identifica e Ã© socialmente reconhecida, conforme art. 2Âº, Â§ 2Âº, Decreto Estadual 55588/2010</p>
          </div>

          <div class="checkbox-container">
            <mat-checkbox formControlName="hasSocialName">Possui Nome Social?:</mat-checkbox>
          </div>

          @if (mostrarcivilName) {
            <div>
              <mat-form-field class="full-input">
                <mat-label>Nome Completo Civil:</mat-label>
                <input matInput id="civilName" formControlName="civilName" type="text"
                       placeholder="Digite seu nome civil"/>
              </mat-form-field>
            </div>
          }

          <div class="inline-container">
            <div class="campo">
              <mat-form-field class="full-input">
                <mat-label>E-mail:</mat-label>
                <input matInput formControlName="email" type="email" placeholder="exemplo@email.com"/>
                @if (userForm.get('email')?.hasError('required')) {
                  <mat-error>O e-mail Ã© obrigatÃ³rio.</mat-error>
                }
                @if (userForm.get('email')?.hasError('email')) {
                  <mat-error>Formato de e-mail invÃ¡lido.</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="campo">
              <mat-form-field class="full-input">
                <mat-label>Login:</mat-label>
                <input matInput id="username" formControlName="username" type="text"/>
              </mat-form-field>
            </div>

          </div>
        </fieldset>
        <!-- CONTATOS -->
        <fieldset>
          <legend>Contatos</legend>
          <div class="inline-container">
            <div class="campo">
              <mat-form-field class="full-input">
                <mat-label>Telefone:</mat-label>
                <input matInput id="phone" formControlName="phone" type="text" placeholder="(xx) xxxxx-xxxx" inputmode="numeric"
                       maxlength="15" appPhoneMask/>
                @if (getControl('phone')?.hasError('required')) {
                  <mat-error>O telefone Ã© obrigatÃ³rio.</mat-error>
                }
                @if (getControl('phone')?.hasError('pattern')) {
                  <mat-error>O formato Ã© invÃ¡lido. Utilize (XX) XXXX-XXXX</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="campo">
              <mat-form-field class="full-input">
                <mat-label>Celular:</mat-label>
                <input matInput id="cellphone" formControlName="cellphone" type="text" placeholder="(xx) xxxxx-xxxx" inputmode="numeric"
                       maxlength="15"  appPhoneMask/>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>E-mail Alternativo:</mat-label>
                <input matInput id="email2" formControlName="email2" type="email"
                       placeholder="exemplo@email.com"/>
                @if (getControl('email2')?.hasError('email')) {
                  <mat-error>Formato de e-mail invÃ¡lido.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </fieldset>

        <!-- DADOS PESSOAIS -->
        <fieldset>
          <legend>Dados Pessoais</legend>
          <div class="inline-container">
            <div>
              <mat-form-field class="full-input">
                <mat-label>Data de Nascimento:</mat-label>
                <input matInput type="date" formControlName="born"/>
                @if (getControl('born')?.hasError('required')) {
                  <mat-error>A data de nascimento Ã© obrigatÃ³ria.</mat-error>
                }
              </mat-form-field>
            </div>

            <div>
              <mat-form-field class="full-input">
                <mat-label>Nacionalidade:</mat-label>
                <mat-select id="nationality" formControlName="nationality">
                  @for (n of nationality; track n) {
                    <mat-option [value]="n.value">{{ n.viewValue }}</mat-option>
                  }
                  @if (getControl('nationality')?.hasError('required')) {
                    <mat-error>A nacionalidade Ã© obrigatÃ³ria.</mat-error>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!-- Troca campo estado e cidade de nascimento -->
          <div class="inline-container">
            @if (userForm.controls['nationality'].value === 'brasileira') {
              <!-- UF de Nascimento -->
              <div>
                <mat-form-field class="full-input">
                  <mat-label>UF de Nascimento:</mat-label>
                  <mat-select formControlName="stateBirth">
                    @for (state of statesApi; track state.id) {
                      <mat-option [value]="state.id">{{ state.sigla }}</mat-option>
                    }
                  </mat-select>
                  @if (getControl('stateBirth')?.hasError('required')) {
                    <mat-error>O estado Ã© obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- Cidade de Nascimento -->
              <div>
                <mat-form-field class="full-input">
                  <mat-label>Cidade de Nascimento:</mat-label>
                  <mat-select formControlName="cityBirth">
                    @for (city of cityBirthApi; track city.id) {
                      <mat-option [value]="city.id">{{ city.cidadeNome }}</mat-option>
                    }
                  </mat-select>
                  @if (getControl('city')?.hasError('required')) {
                    <mat-error>A cidade Ã© obrigatÃ³ria.</mat-error>
                  }
                </mat-form-field>
              </div>
            } @else {
              <div>
                <mat-form-field class="full-input">
                  <mat-label>State:</mat-label>
                  <input matInput id="stateBirth2" type="text" formControlName="stateBirth2">
                  @if (getControl('stateBirth2')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-input">
                  <mat-label>City:</mat-label>
                  <input matInput id="cityBirth2" type="text" formControlName="cityBirth2">
                  @if (getControl('cityBirth2')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>

          <div class="inline-container">
            <div>
              <mat-form-field>
                <mat-label>Estado Civil:</mat-label>
                <mat-select id="maritalStatus" formControlName="maritalStatus">
                  @for (m of maritalStatus; track m) {
                    <mat-option [value]="m.value">{{ m.viewValue }}</mat-option>
                  }
                </mat-select>
                @if (getControl('maritalStatus')?.hasError('required')) {
                  <mat-error>O estado civil Ã© obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Sexo</mat-label>
                <select matNativeControl required formControlName="gender">
                  <option value="F">Feminino</option>
                  <option value="M">Masculino</option>
                </select>
                @if (getControl('gender')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>

            </div>
            <div>
              <mat-form-field>
                <mat-label>GÃªnero</mat-label>
                <select matNativeControl required formControlName="gender2">
                  <option value="Feminino">Feminino</option>
                  <option value="Masculino">Masculino</option>
                  <option value="Outro">Outro</option>
                </select>
                @if (getControl('gender')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>Documentos</legend>
          @if (userForm.controls['nationality'].value === 'brasileira') {
            <div class="inline-container">
              <div>
                <mat-form-field class="full-input">
                  <mat-label>RG:</mat-label>
                  <input matInput id="rg" formControlName="rg" type="text"/>
                  @if (getControl('rg')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-input">
                  <mat-label>ÃrgÃ£o Emissor:</mat-label>
                  <input matInput id="rgOrganIssuer" formControlName="rgOrganIssuer" type="text"/>
                  @if (getControl('rgOrganIssuer')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-input">
                  <mat-label>UF de EmissÃ£o:</mat-label>
                  <mat-select formControlName="rgStateIssuer">
                    @for (stateUF of statesApi; track stateUF.id) {
                      <mat-option [value]="stateUF.id">{{ stateUF.sigla }}</mat-option>
                    }
                  </mat-select>
                  @if (getControl('rgStateIssuer')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-input">
                  <mat-label>Data de EmissÃ£o:</mat-label>
                  <input matInput id="rgDateIssuer" type="date" formControlName="rgDateIssuer"/>
                  @if (getControl('rgDateIssuer')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          } @else {
            <div class="inline-container">
              <div>
                <mat-form-field class="full-input">
                  <mat-label>Passaporte:</mat-label>
                  <input matInput id="passaport" formControlName="passaport" type="text"/>
                  @if (getControl('passaport')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-input">
                  <mat-label>Documento de IdentificaÃ§Ã£o:</mat-label>
                  <input matInput id="idDocument" formControlName="idDocument" type="text"/>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-input">
                  <mat-label>RNE:</mat-label>
                  <input matInput id="rneDocument" formControlName="rneDocument" type="text"/>
                  @if (getControl('rneDocument')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          }
          <div class="inline-container">
            <div>
              <mat-form-field class="full-input">
                <mat-label>TÃ­tulo de Eleitor:</mat-label>
                <input matInput id="voterRegistration" formControlName="voterRegistration" type="text"/>
                @if (getControl('voterRegistration')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>Data de EmissÃ£o:</mat-label>
                <input matInput id="voterDate" formControlName="voterDate" type="date"/>
                @if (getControl('voterDate')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>Zona:</mat-label>
                <input matInput id="voterZone" formControlName="voterZone" type="text"/>
                @if (getControl('voterZone')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>SeÃ§Ã£o:</mat-label>
                <input matInput id="voterSection" formControlName="voterSection" type="text"/>
                @if (getControl('voterSection')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>Documento Militar:</mat-label>
                <input matInput id="militaryDocument" formControlName="militaryDocument" type="text"/>
              </mat-form-field>
            </div>
          </div>
        </fieldset>

        <!-- ENDEREÃO -->
        <fieldset>
          <legend>EndereÃ§o</legend>
          <div class="inline-container">
            <div class="campo-radio">
              <mat-radio-group formControlName="whereLive" aria-label="Selecione uma opÃ§Ã£o">
                <mat-radio-button value="in-brazil">Resido no Brasil</mat-radio-button>
                <mat-radio-button value="in-exterior">I live outside Brazil</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <!-- Campos quando reside no Brasil -->
          <div class="inline-container">
            <div>
              <mat-form-field class="full-input">
                @if (userForm.controls['whereLive'].value === 'in-exterior') {
                  <mat-label>ZipCode:</mat-label>
                } @else {
                  <mat-label>CEP:</mat-label>
                }
                <input matInput id="postalCode" type="text" formControlName="postalCode" appCepMask>
                @if (getControl('postalCode')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>

            <div>
              <mat-form-field class="full-input">
                @if (userForm.controls['whereLive'].value === 'in-exterior') {
                  <mat-label>Address:</mat-label>
                } @else {
                  <mat-label>EndereÃ§o:</mat-label>
                }
                <input matInput id="address" type="text" formControlName="address">
                @if (getControl('address')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                @if (userForm.controls['whereLive'].value === 'in-exterior') {
                  <mat-label>Number:</mat-label>
                } @else {
                  <mat-label>NÃºmero:</mat-label>
                }
                <input matInput id="addressNumber" type="text" formControlName="addressNumber">
                @if (getControl('addressNumber')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>

          </div>
          <div class="inline-container">
            <div>
              <mat-form-field class="full-input">
                @if (userForm.controls['whereLive'].value === 'in-exterior') {
                  <mat-label>Complement:</mat-label>
                } @else {
                  <mat-label>Complemento:</mat-label>
                }
                <input matInput id="addressComplement" type="text" formControlName="addressComplement">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                @if (userForm.controls['whereLive'].value === 'in-exterior') {
                  <mat-label>District:</mat-label>
                } @else {
                  <mat-label>Bairro:</mat-label>
                }
                <input matInput id="district" type="text" formControlName="district">
                @if (getControl('district')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>

            <div>
              <mat-form-field class="full-input">
                <mat-label>PaÃ­s:</mat-label>
                <input matInput id="country" type="text" formControlName="country">
                @if (getControl('country')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <!-- Troca campo estado e cidade do endereÃ§o -->
          <div class="inline-container">
            @if (userForm.controls['whereLive'].value === 'in-brazil') {
              <div>
                <mat-form-field class="full-input">
                  <mat-label>Estado:</mat-label>
                  <mat-select id="state" formControlName="state">
                    @for (stateA of statesApi; track stateA.id) {
                      <mat-option [value]="stateA.id">{{ stateA.sigla }}</mat-option>
                    }
                  </mat-select>
                  @if (getControl('state')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-input">
                  <mat-label>Cidade:</mat-label>
                  <mat-select id="city" formControlName="city">
                    @for (cityA of cityApi; track cityA.id ) {
                      <mat-option [value]="cityA .id">{{ cityA.cidadeNome }}</mat-option>
                    }
                  </mat-select>
                  @if (getControl('city')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
            } @else {
              <div>
                <mat-form-field class="full-input">
                  <mat-label>State:</mat-label>
                  <input matInput id="state2" type="text" formControlName="state2">
                  @if (getControl('state2')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="full-input">
                  <mat-label>City:</mat-label>
                  <input matInput id="city2" type="text" formControlName="city2">
                  @if (getControl('city2')?.hasError('required')) {
                    <mat-error>Campo obrigatÃ³rio.</mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>
        </fieldset>

        <!-- COMPLEMENTO -->
        <fieldset>
          <legend>Complemento</legend>
          <div class="inline-container">
            <div>
              <mat-form-field class="full-input">
                <mat-label>ProfissÃ£o:</mat-label>
                <input matInput id="profession" formControlName="profession" type="text">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>Local de Trabalho:</mat-label>
                <input matInput id="workplace" formControlName="workplace" type="text">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>Escolaridade</mat-label>
                <mat-select formControlName="degree">
                  @for (d of degree; track d) {
                    <mat-option [value]="d.value">{{ d.viewValue }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

          </div>
          <p>Referente ao seu curso de GraduaÃ§Ã£o, informe a seguir o nome do Curso e o nome da Universidade onde
            foi
            concluÃ­do</p>
          <div class="inline-container">
            <div>
              <mat-form-field class="full-input">
                <mat-label>Nome do Curso de GraduaÃ§Ã£o:</mat-label>
                <input matInput id="graduationCourse" formControlName="graduationCourse" type="text">
                @if (getControl('graduationCourse')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>Nome da Faculdade/Universidade:</mat-label>
                <input matInput id="graduationCourseInstitution"
                       formControlName="graduationCourseInstitution" type="text">
                @if (getControl('graduationCourseInstitution')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-input">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="graduationCourseState">
                  @for (stateG of statesApi; track stateG.id) {
                    <mat-option [value]="stateG.id">{{ stateG.sigla }}</mat-option>
                  }
                </mat-select>
                @if (getControl('graduationCourseState')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>

            </div>

            <div>
              <mat-form-field class="full-input">
                <mat-label>Cidade</mat-label>
                <mat-select formControlName="graduationCourseCity">
                  @for (cityG of cityGraduationApi; track cityG.id) {
                    <mat-option [value]="cityG.id">{{ cityG.cidadeNome }}</mat-option>
                  }
                </mat-select>
                @if (getControl('graduationCourseCity')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>

            <div>
              <mat-form-field class="full-input">
                <mat-label>Data de ConclusÃ£o:</mat-label>
                <input matInput id="graduationCourseDate" formControlName="graduationCourseDate"
                       type="date">
                @if (getControl('graduationCourseDate')?.hasError('required')) {
                  <mat-error>Campo obrigatÃ³rio.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <div class="inline-container">
            <p>Possui DeficiÃªncia, Transtorno Global do Desenvolvimento ou Altas Habilidades/SuperdotaÃ§Ã£o?</p>
          </div>
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoCegueira">Cegueira</mat-checkbox>
          </div>
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoVisaoSubnormal">Visao Subnormal</mat-checkbox>
          </div>
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoSurdez">Surdez</mat-checkbox>
          </div>
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoDeficienciaAuditiva">DeficiÃªncia auditiva</mat-checkbox>
          </div>
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoSurdocegueira">Surdocegueira</mat-checkbox>
          </div>
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoDeficienciaFisica">DeficiÃªncia fÃ­sica</mat-checkbox>
          </div>
          @if (userForm.get('censoDeficienciaFisica')?.value) {
            <div>
              <p>VocÃª apresenta dificuldades motoras para se locomover na universidade, faz uso de cadeira de rodas e/ou
                utiliza equipamentos eletrÃ´nicos adaptados (ponteira de cabeÃ§a, mouse, canetas etc.) para acessar o
                conteÃºdo da internet ou dispositivos mÃ³veis? Faz uso de sistemas de comunicaÃ§Ã£o alternativa?</p>
              <mat-form-field class="full-input">
                <mat-label>Se sim, de qual faz uso?</mat-label>
                <input matInput id="censoDeficienciaFisicaDescricao" type="text"
                       formControlName="censoDeficienciaFisicaDescricao">
              </mat-form-field>
            </div>
          }
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoDeficienciaIntelectual">DeficiÃªncia intelectual</mat-checkbox>
          </div>
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoDeficienciaMultipla">DeficiÃªncia mÃºltipla</mat-checkbox>
          </div>
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoTea">Transtorno do Espectro Autista - TEA</mat-checkbox>
          </div>
          @if (userForm.get('censoTea')?.value) {
            <div>
              <mat-form-field class="full-input">
                <mat-label>Quais condiÃ§Ãµes vocÃª tem dentro do Espectro?</mat-label>
                <input matInput id="censoTeaDescricao" type="text" formControlName="censoTeaDescricao">
              </mat-form-field>
            </div>
          }
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoAltasHabilidades">Altas habilidades/SuperdotaÃ§Ã£o</mat-checkbox>
          </div>
          @if (userForm.get('censoAltasHabilidades')?.value) {
            <mat-form-field>
              <mat-label>Altas Habilidades</mat-label>
              <select matNativeControl formControlName="censoAltasHabilidadesTipo">
                <option value="censo_altas_habilidades_academica">AcadÃªmica</option>
                <option value="censo_altas_habilidades_motora">Motora</option>
                <option value="censo_altas_habilidades_cognitiva">Cognitiva</option>
                <option value="censo_altas_habilidades_lideranca">LideranÃ§a</option>
                <option value="censo_altas_habilidades_criatividade">Criativa</option>
                <option value="censo_altas_habilidades_artistica">Artistica</option>
              </select>
            </mat-form-field>
          }
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoOutras">Outras</mat-checkbox>
          </div>
          @if (userForm.get('censoOutras')?.value) {
            <div>
              <mat-form-field class="full-input">
                <mat-label>Se sim, especificar</mat-label>
                <input matInput id="censoOutrasDesc" type="text" formControlName="censoOutrasDesc">
              </mat-form-field>
            </div>
          }
          <div class="checkbox-container">
            <mat-checkbox formControlName="censoNaoInformar">Prefiro nÃ£o informar</mat-checkbox>
          </div>
          <div class="inline-container">
            <p>Caso vocÃª tenha assinalado mais de uma das alternativas descreva em ordem de prioridade qual a sua
              necessidade especÃ­fica:</p>
          </div>
          <div>
            <mat-form-field class="full-input">
              <mat-label>1</mat-label>
              <input matInput id="censoDescPrioridade1" type="text" formControlName="censoDescPrioridade1">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-input">
              <mat-label>2</mat-label>
              <input matInput id="censoDescPrioridade2" type="text" formControlName="censoDescPrioridade2">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-input">
              <mat-label>3</mat-label>
              <input matInput id="censoDescPrioridade3" type="text" formControlName="censoDescPrioridade3">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-input">
              <mat-label>4</mat-label>
              <input matInput id="censoDescPrioridade4" type="text" formControlName="censoDescPrioridade4">
            </mat-form-field>
          </div>

        </fieldset>

        <!-- ACESSIBILIDADE -->
        <fieldset>
          <legend>Acessibilidade</legend>
          <div class="campo-radio">
            <mat-radio-group formControlName="acessibility" aria-label="Selecione uma opÃ§Ã£o">
              <mat-radio-button value="semrecursos">Sem recursos</mat-radio-button>
              <mat-radio-button value="libraslegenda">Libras e Legendas</mat-radio-button>
              <mat-radio-button value="audiodescricao">AudiodescriÃ§Ã£o</mat-radio-button>
            </mat-radio-group>
          </div>
        </fieldset>
        <div class="button-container">
          <button mat-raised-button color="primary" (click)="onAttemptSubmit()">
            <mat-icon>save</mat-icon>
            Salvar
          </button>
        </div>
      </form>
    }
    @if (!isLoading && !user) {
      <div class="no-user-message"> Nenhum usuÃ¡rio encontrado.</div>
    }

  </div>


</div>
